
import React from 'react';
import { PageSection } from '../../../types';
import { StoreImage } from '../../ui/StoreImage';

interface ContentSectionProps {
    section: PageSection;
}

export const ContentSection: React.FC<ContentSectionProps> = ({ section }) => {
    const isImageRight = section.layout === 'image-right';

    return (
        <div className="py-20 px-6 bg-background overflow-hidden">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-12 md:gap-24">
                
                {/* Image */}
                <div className={`w-full md:w-1/2 ${isImageRight ? 'md:order-last' : ''}`}>
                    <div className="relative rounded-3xl overflow-hidden shadow-2xl rotate-1 hover:rotate-0 transition-transform duration-500">
                        <StoreImage
                            src={section.imageUrl}
                            width={1080}
                            loading="lazy"
                            decoding="async"
                            alt={section.title || "Klassförsäljning av kaffe"} 
                            className="w-full h-auto object-cover"
                        />
                        <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-3xl"></div>
                    </div>
                </div>

                {/* Text */}
                <div className="w-full md:w-1/2">
                    <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary mb-6 leading-tight">
                        {section.title}
                    </h2>
                    <p className="text-lg text-secondary leading-relaxed font-light">
                        {section.text}
                    </p>
                </div>

            </div>
        </div>
    );
};
